import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";

export default function PropModal({ isOpen, setIsOpen }) {
  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="flex w-[448px] max-w-[448px] flex-col items-center gap-6 rounded-lg border border-gray-300 bg-white p-6 shadow-lg">
          {/* Header */}
          <div className="w-full flex justify-between items-center">
            <h2 className="text-lg font-semibold">Missing data</h2>
            <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700">
            <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          {/* Description */}
          <p className="text-start text-[#374151]">
            Looks like you have not filled in one or more of the fields.
          </p>

          {/* Footer with Buttons */}
          <div className="w-full flex justify-end gap-4">
            <button
              onClick={() => setIsOpen(false)}
              className="px-4 py-2 text-white bg-[#900] rounded"
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-white bg-[#900] rounded "
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    )
  );
}
